"use client";

import {
  createContext,
  ReactNode,
  useCallback,
  useContext,
  useState,
} from "react";
import { OverCapacityModal } from "./modal";

interface OverCapacityContextValue {
  showOverCapacityError: (errorType: string) => void;
}

const OverCapacityContext = createContext<OverCapacityContextValue | undefined>(
  undefined,
);

export function useOverCapacity() {
  const context = useContext(OverCapacityContext);
  if (!context) {
    throw new Error("useOverCapacity must be used within OverCapacityProvider");
  }
  return context;
}

interface OverCapacityProviderProps {
  children: ReactNode;
}

export function OverCapacityProvider({ children }: OverCapacityProviderProps) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [errorType, setErrorType] = useState<string>("");

  const showOverCapacityError = useCallback((errorType: string) => {
    setErrorType(errorType);
    setIsModalOpen(true);
  }, []);

  const handleCloseModal = useCallback(() => {
    setIsModalOpen(false);
    // モーダルが完全に閉じた後にエラータイプをクリア
    // これによりモーダルのフェードアウトアニメーション中にエラーメッセージが消えるのを防ぐ
    setTimeout(() => {
      setErrorType("");
    }, 300); // アニメーション時間に合わせて調整
  }, []);

  const contextValue: OverCapacityContextValue = {
    showOverCapacityError,
  };

  return (
    <OverCapacityContext value={contextValue}>
      {children}
      <OverCapacityModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        errorType={errorType}
      />
    </OverCapacityContext>
  );
}
